import { HttpErrorResponse } from '@angular/common/http'

/**
 * Resolve an unknown error into an i18n key for display. Never returns a raw
 * `Error.message` — backend strings should not leak through the translate pipe.
 * Callers should log the underlying error separately to retain diagnostics.
 */
export function errorMessage(err: unknown, fallbackKey: string): string {
  if (err instanceof HttpErrorResponse) {
    if (err.status === 0) {
      return 'errors.network'
    }
    if (err.status === 401) {
      return 'errors.unauthorized'
    }
    if (err.status === 403) {
      return 'errors.forbidden'
    }
    if (err.status === 404) {
      return 'errors.not-found'
    }
    if (err.status === 504) {
      return 'errors.timeout'
    }
    if (err.status >= 500) {
      return 'errors.server'
    }
  }
  return fallbackKey
}
